import {
    AlertDialog,
    AlertDialogAction,
    AlertDialogCancel,
    AlertDialogContent,
    AlertDialogDescription,
    AlertDialogFooter,
    AlertDialogHeader,
    AlertDialogTitle,
} from '@/components/ui/alert-dialog';
import authService from '@/services/zybook-auth-service';

export function ZySignOutAlert({
    showSignOutAlert,
    setShowSignOutAlert,
}: {
    showSignOutAlert: boolean;
    setShowSignOutAlert: (showSignOutAlert: boolean) => void;
}) {
    function handleSignOut() {
        authService.signOut();
    }

    return (
        <AlertDialog
            open={showSignOutAlert}
            onOpenChange={setShowSignOutAlert}
        >
            <AlertDialogContent>
                <AlertDialogHeader>
                    <AlertDialogTitle>Sign out</AlertDialogTitle>
                    <AlertDialogDescription>Are you sure you want to sign out?</AlertDialogDescription>
                </AlertDialogHeader>
                <AlertDialogFooter>
                    <AlertDialogCancel>Cancel</AlertDialogCancel>
                    <AlertDialogAction onClick={handleSignOut}>Sign out</AlertDialogAction>
                </AlertDialogFooter>
            </AlertDialogContent>
        </AlertDialog>
    );
}
